import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { adminCreateBailiffSchema } from 'utils/validate';
import { useNavigate } from 'react-router-dom';
import { adminCreateUser } from 'services/user';
import { useCallback, useRef, useState } from 'react';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { useFlash } from 'contexts/flash';
import axios from 'axios';
import { useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAP_LIBRARIES } from 'app/components/modules/ModalNewLead/hook';
export type CreateBailiffForm = {
  firstName: string;
  lastName: string;
  email: string;
  address: string;
};
export const useInjection = () => {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const fileInputDocumentRef = useRef<HTMLInputElement | null>(null);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    libraries: GOOGLE_MAP_LIBRARIES,
    googleMapsApiKey: process.env.REACT_APP_MAP_KEY!
  });

  const { setFlash } = useFlash();
  const [fileDocument, setFileDocument] = useState<{ file: File; url: string }[]>([]);
  const {
    handleSubmit,
    register,
    control,
    setValue,
    formState: { errors }
  } = useForm<CreateBailiffForm>({ resolver: yupResolver(adminCreateBailiffSchema) });

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (!fileList) return;
    const newFiles = Array.from(fileList);
    const fileConvert = newFiles.map((item) => ({
      file: item,
      url: URL.createObjectURL(new Blob([item], { type: item?.type }))
    }));
    setFileDocument((prevFiles) => [...prevFiles, ...fileConvert]);
  };

  const handleDeleteDocument = (indexToDelete: number) => {
    setFileDocument((prevFiles) => prevFiles.filter((_, index) => index !== indexToDelete));
  };

  const createUser = useCallback(
    async (value: CreateBailiffForm) => {
      const formData = new FormData();
      let arrayIdFile: number[] = [];
      if (fileDocument.length) {
        for (let x = 0; x < fileDocument.length; x++) {
          formData.append('files', fileDocument[x].file, fileDocument[x].file.name);
        }
        const { data: resListIdFile } = await axios.post('/storages/bailiffs-document', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        arrayIdFile = resListIdFile.files;
      }
      const payload = {
        ...value,
        isActive: false,
        role: 'USER',
        documentIds: arrayIdFile
      };
      await adminCreateUser(payload);
      setFlash({ type: 'success', message: 'Create new bailiff successful' });
      navigate('/admin/control-panel?tab=bailiffs');
    },
    [fileDocument, navigate, setFlash]
  );

  const { asyncCallback: asyncCreateUser } = useAsyncCallback(createUser, []);

  return {
    control,
    handleSubmit,
    register,
    errors,
    asyncCreateUser,
    setValue,
    fileInputDocumentRef,
    handleFileChange,
    fileDocument,
    handleDeleteDocument,
    isLoaded,
    inputRef
  };
};
